import type { RootState } from '@/store';

export const selectActiveContext = (state: RootState) => state.activeContext;

export const selectActiveEnterpriseId = (state: RootState) =>
  selectActiveContext(state).activeEnterpriseId ?? '';
